import { DateTime } from 'luxon'

import { Box, Comment as CommentBase } from '@domain-group/suit-theme'

import useAttachments from '@hooks/useAttachments'
import useComment from '@hooks/useComment'
import { useRelations as useUserRelations } from '@hooks/useUser'

import type { CommentModel } from '@models/types'

import Attachment from './Attachment'

interface BrandedArtworkCommentProps {
  comment: Partial<CommentModel>,
  hasLatestAttachment: boolean,
  isFirstComment: boolean,
  isLastComment: boolean,
}

const BrandedArtworkComment = (props: BrandedArtworkCommentProps) => {
  const {
    comment, hasLatestAttachment, isFirstComment, isLastComment,
  } = props

  const commentPayload = useComment(comment)
  const { comment: { body, public: isPublic }, user } = commentPayload

  const { filteredAttachments, hasFilteredAttachments } = useAttachments({
    filters: {
      attachable_id: comment.id,
      attachable_type: 'Comment',
    },
  })

  const { image } = useUserRelations(user)

  // @ts-expect-error TS2339
  const createdDateString = comment?.dates?.created?.date_time || ''

  return (
    <>
      <CommentBase
        boxProps={{
          borderBottom: hasFilteredAttachments || isLastComment ? 'none' : '1px dashed',
          marginBottom: hasFilteredAttachments || isLastComment ? 0 : 'large',
          paddingTop: !isFirstComment ? 'large' : 'none',
        }}
        callbacks={{ deleteComment: () => undefined }}
        // @ts-expect-error TS2322
        commentBody={body}
        commentTime={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
        fullName={user.full_name}
        // @ts-expect-error TS2339
        imageUrl={image.thumb_url}
        // @ts-expect-error TS2322
        isPublic={isPublic}
      />

      {hasFilteredAttachments && (
        <Box
          borderBottom={isLastComment ? 'none' : '1px dashed'}
          borderColor="lineColor"
        >
          <Box
            alignItems="center"
            borderTop="1px dashed"
            borderColor="lineColor"
            justifyContent="space-between"
            marginLeft="45px"
            paddingBottom="medium"
          >
            {filteredAttachments.reverse().map(attachment => (
              <Attachment key={attachment.id} attachment={attachment} outdated={!hasLatestAttachment} />
            ))}
          </Box>
        </Box>
      )}
    </>
  )
}

export default BrandedArtworkComment
